import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomCheckbox,
  CustomButton,
} from '../../../../common/components';

const AllotmentDialog = ({
  open,
  onClose,
  editMode,
  selectedAllotment,
  onInputChange,
  onSave,
  imageFile,
  imageError,
  onImageChange,
  canEditLots = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    if (!imageFile) {
      setPreviewUrl('');
      return undefined;
    }
    const objectUrl = URL.createObjectURL(imageFile);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [imageFile]);

  const currentImageUrl = previewUrl || selectedAllotment?.image_url || '';

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'sm'}>
      <DialogTitle>{editMode ? 'Editar Loteo' : 'Agregar Loteo'}</DialogTitle>

      <DialogBody>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2 }}>
          <CustomTextField
            label="Nombre"
            name="name"
            value={selectedAllotment?.name || ''}
            onChange={onInputChange}
            placeholder="Ej: Barrio El Molino"
          />
          <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="subtitle2">Plano del loteo</Typography>
            {currentImageUrl ? (
              <Box
                component="img"
                src={currentImageUrl}
                alt={selectedAllotment?.name || 'Plano del loteo'}
                sx={{
                  width: '100%',
                  maxHeight: 220,
                  objectFit: 'contain',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: 'background.paper',
                }}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                No hay imagen cargada.
              </Typography>
            )}
            <CustomButton
              component="label"
              variant="outlined"
              disabled={!canEditLots}
              sx={{ width: { xs: '100%', sm: 'fit-content' } }}
            >
              {editMode ? 'Cambiar imagen' : 'Seleccionar imagen'}
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={(event) => {
                  const file = event.target.files?.[0] || null;
                  onImageChange?.(file);
                }}
              />
            </CustomButton>
            {imageError && (
              <Typography variant="caption" color="error.main">
                {imageError}
              </Typography>
            )}
          </Box>
          <CustomCheckbox
            name="is_active"
            label="Activo"
            checked={Boolean(selectedAllotment?.is_active)}
            onChange={onInputChange}
          />
        </Box>
      </DialogBody>

      <DialogActions
        handleClose={onClose}
        handleSave={onSave}
        saveButtonProps={{ disabled: !canEditLots }}
      />
    </DialogContainer>
  );
};

export default AllotmentDialog;
